import React from 'react';

class CheckDiffText extends React.PureComponent {
    render() {
        const { oldValue, newValue } = this.props;

        if (newValue === oldValue) {
            return <span>{oldValue}</span>;
        } 
        return (
            <span className="dirty-text">
                <span className='old'>{oldValue}</span>
                <span className='new'>{newValue}</span>
            </span>
        );
    }
}

export default CheckDiffText;



// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/CheckDiffText.jsx